import { PathsV1OpenPositionSearchPostParametersQueryExtend } from "@/api-schema-enums";
import { alphartisApiAxios } from "@/config/axios";
import { useQuery } from "@tanstack/react-query";
import {
  OPEN_POSITION_RESOURCE,
  OPEN_POSITION_SEARCH_API_PATH,
  type OpenPosition,
  type OpenPositionSearchBody,
  type OpenPositionSearchResponse,
} from "./use-open-position-search.query";

export const OPEN_POSITION_DETAIL_OPERATION = "detail" as const;

const OPEN_POSITION_DETAIL_EXTEND = [
  PathsV1OpenPositionSearchPostParametersQueryExtend.Customer,
  PathsV1OpenPositionSearchPostParametersQueryExtend.Company,
  PathsV1OpenPositionSearchPostParametersQueryExtend.Branch,
  PathsV1OpenPositionSearchPostParametersQueryExtend.DunningBlock,
] as const;

export function useOpenPositionByUuidQuery(uuid: string) {
  const requestParameters = { extend: [...OPEN_POSITION_DETAIL_EXTEND], page: 1, pageSize: 1, includeCount: false };

  return useQuery({
    queryKey: [OPEN_POSITION_RESOURCE, OPEN_POSITION_DETAIL_OPERATION, uuid, { parameters: requestParameters }],
    queryFn: async (): Promise<OpenPosition | null> => {
      const body: OpenPositionSearchBody = { uuid: [uuid] };
      const response = await alphartisApiAxios.post<OpenPositionSearchResponse>(OPEN_POSITION_SEARCH_API_PATH, body, {
        params: requestParameters,
      });

      return response.data.data[0] ?? null;
    },
    enabled: !!uuid,
  });
}
